/* eslint-disable no-unused-vars */
import { VuelidateValidation } from "../schema/schema_utils";

export default {
    validations() {
        let vm = this;
        return {
            item: VuelidateValidation(vm.schema),
        };
    },
};
